import { render, staticRenderFns } from "./ihead.vue?vue&type=template&id=6291bb8b&scoped=true&"
import script from "./ihead.vue?vue&type=script&lang=js&"
export * from "./ihead.vue?vue&type=script&lang=js&"
import style0 from "./ihead.vue?vue&type=style&index=0&id=6291bb8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6291bb8b",
  null
  
)

export default component.exports